import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

function LoggedOut({ location }) {
    const queryString = qs.parse(location.search, { ignoreQueryPrefix: true });

    const automaticRedirectAfterSignOut = queryString.automaticredirectaftersignout;
    const postLogoutRedirectUri = queryString.postlogoutredirecturl;
    const clientName = queryString.clientname;
    const signOutIframeUrl = queryString.signoutiframeurl;

    useEffect(() => {
        (async () => {
            if (postLogoutRedirectUri) {
                window.location = postLogoutRedirectUri;
            };
        })();
    }, [postLogoutRedirectUri]);

    return (
        <>
            <Helmet>
                <title>Signed Out | CBRN Network</title>
            </Helmet>
            <div id="applicationHost">
                <div className="shell">
                    <div className="main-content" id="mainContent" tabIndex="-1">
                        <div className="page-host">
                            <div class="page-header logged-out">
                                {automaticRedirectAfterSignOut === false || postLogoutRedirectUri == null ?
                                    <h1>
                                        <small>You are now signed out</small>
                                    </h1> :
                                    <h1 class="text-center">
                                        <p>Signed out</p>
                                        <i class="fa fa-solid fa-lg fa-spinner fa-spin"></i>
                                    </h1>}

                                {postLogoutRedirectUri != null ?
                                    <>{
                                        automaticRedirectAfterSignOut ?
                                            <div class="text-center">
                                                    If not automatically redirected, click <a title={`Navigate to ${clientName}`} class="PostLogoutRedirectUri" href={postLogoutRedirectUri}>here</a> to return to the <span>{clientName}</span>.
                                            </div> :
                                            <div>
                                                    Click <a class="PostLogoutRedirectUri" href={postLogoutRedirectUri}>here</a> to return to the <span>{clientName}</span> application.
                                            </div>
                                    }</> : ''}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default withRouter(LoggedOut);
